export default __webpack_public_path__ + "static/media/thumbnail.afedca44.png";